import { createSlice } from '@reduxjs/toolkit';

export const initialFilterState = {
    schoolClientsFilter: {
        search: "",
        division: "",
        school: "",
        status: { label: "Active", value: "active" },
        sort: {
            column: "lastname",
            direction: "asc",
        },
    },

    taskPlanTemplateFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },

    supportStaffFilter: {
        search: "",
        status: "",
        school: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },


    supportStaffTaskListFilter: {
        status: "",
        grade: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },

    taskPlanTemplateLibraryFilter: {
        search: "",
    },

    taskPlanFilter: {
        search: "",
        client_type: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },

    userProfileFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },

}

const filterSlice = createSlice({
    name: 'auth',
    initialState: initialFilterState,
    reducers: {
        schoolClientsFilter: (state, action) => {
            const filter = action.payload;
            state.schoolClientsFilter = filter;
        },
        taskPlanTemplateFilter: (state, action) => {
            const filter = action.payload;
            state.taskPlanTemplateFilter = filter;
        },
        supportStaffFilter: (state, action) => {
            const filter = action.payload;
            state.supportStaffFilter = filter;
        },
        taskPlanFilter: (state, action) => {
            const filter = action.payload;
            state.taskPlanFilter = filter;
        },

        supportStaffTaskListFilter: (state, action) => {
            const filter = action.payload;
            state.supportStaffTaskListFilter = filter;
        },

        taskPlanTemplateLibraryFilter: (state, action) => {
            const filter = action.payload;
            state.taskPlanTemplateLibraryFilter = filter;
        },

        userProfileFilter: (state, action) => {
            const filter = action.payload;
            state.userProfileFilter = filter;
        },

    },
});

export const {
    schoolClientsFilter,
    taskPlanTemplateFilter,
    taskPlanFilter,
    taskPlanTemplateLibraryFilter,
    supportStaffTaskListFilter,
    supportStaffFilter,
    userProfileFilter
} = filterSlice.actions;

export default filterSlice.reducer;